import { useCallback, useState, type ReactNode } from 'react';

import { useUserDetails } from '@/features/_shared/user';
import { useDashboardEditLockContext } from '@/features/dashboard';

import type { BaseTabType } from '../../types';
import AddToDashboardMenu from './AddToDashboardMenu';

export type WidgetActionState = {
  disabled: boolean;
  openFrom: (anchor: HTMLElement) => void;
  layer: ReactNode;
};

export function useAddToDashboardAction(
  tab: BaseTabType,
  options?: { onAdded?: () => void }
): WidgetActionState {
  const { isUserExpired } = useUserDetails();
  const { requestExclusiveAction } = useDashboardEditLockContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openFrom = useCallback(
    (anchor: HTMLElement) => {
      requestExclusiveAction(() => {
        setAnchorEl(currentAnchor => (currentAnchor ? null : anchor));
      });
    },
    [requestExclusiveAction]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    disabled: Boolean(isUserExpired),
    openFrom,
    layer: (
      <AddToDashboardMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        tab={tab}
        onAdded={options?.onAdded}
        onClose={handleClose}
      />
    )
  };
}
